import { GET, POST, PUT } from "./common/http";
import { BASE_URL } from "./common/const";
import axios from "axios";

export const UploadProfile = (formData: FormData) => {
    return axios.post(`${BASE_URL}/upload-profile`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};